import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=6fbc48ae&scoped=true&lang=pug"
import script from "./skeleton.vue?vue&type=script&lang=ts"
export * from "./skeleton.vue?vue&type=script&lang=ts"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=6fbc48ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc48ae",
  null
  
)

export default component.exports